var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_vm._t("container"),(_vm.showTooltip)?_c('div',{staticClass:"tooltiptext c-text-b3 ui-shadow-md c-text-gray-400"},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }